import axios from 'axios';

const coreApi = axios.create({
		baseURL: `//${process.env.VUE_APP_API_HOST}`,
	}),
	getCountryCode = () => coreApi.get('geoip/v1/country').then((result) => (result && result.data && result.data.country) || '');

export default {
	getCountryCode,
};
